import type { PathConfig } from '@react-navigation/native';
import { groupMembersLinking } from 'app/screens/groups/group-members.linking';
import type { Parameters } from './navigator';

export const linking: PathConfig<Parameters> = {
  path: '/profile',
  screens: {
    'account-deletion': '/delete',
    'calendar-setting': '/calendar-setting',
    'contact-us': '/contact-us',
    'my-address': '/my-address/:id',
    'change-password': '/change-password',
    'my-information': '/my-information',
    'my-plan': '/my-plan',
    streak: '/streak',
    'streak-members': '/streak/members/:period',
    'super-partageur': '/super-partageur',
    'super-partageur-details': '/super-partageur-details',
    ambassador: '/ambassador',
    'my-impact-financial': '/my-impact-financial',
    'my-preferences': '/my-preferences',
    'my-ratings': '/my-ratings',
    'notifications-chat-setting': '/notifications-chat-setting',
    'notifications-need-setting': '/notifications-need-setting',
    'notifications-setting': '/notifications-setting',
    'profile-overview': '/overview',
    unavailable: '/unavailable',
    language: '/language',
    payment: '/payment',
    privacy: '/privacy',
    'group-members': groupMembersLinking,
    'my-clubs': '/my-clubs',
    'my-interests': '/my-interests',
    'my-neighbourhood': '/my-neighbourhood/:addressId',
    'activity-sectors': '/activity-sectors',
  },
};
